
import { getTemplateString } from 'common/helpers/string';
import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';

interface Props {
    PageData?: any;
    Model?: any;
}


const GenericErrorPageData = (props: Props) => {
    const { Model, PageData } = props;
    const LOGO_ICONS_PATH = `${process.env.PUBLIC_URL}/images/logo/`;
    const errorLogo = `${LOGO_ICONS_PATH}/oops.svg`;
    const [eventTracked, setEventTracked] = useState<boolean>(false);
    const errorMessage = getTemplateString(
        PageData?.ErrorMessage,
      );
    var tagManagerArgs: any;
    useEffect(() => {
    if (eventTracked == false) {
     
        tagManagerArgs = {
          dataLayer: {
            event: 'unexpected_error',
          },
        };
        TagManager.dataLayer(tagManagerArgs);      
      setEventTracked(true);
    }
  }, [Model]);
    return (
        <div className="Section--secondaryBg">
    <div className="Page-container PageContainer--transparent">
        <article className="Article">
            <div className="Grid Grid--gutterHlg">
                <div className="Grid-cell u-size1of1">
                    <div className="Statepage">
                        <div className="Statepage-icon">
                            <img src={errorLogo}/>
                        </div>
                        <h2 className="Heading Statepage-heading">
                            {PageData?.Header}
                        </h2>
                        {/* <div className="Statepage-text">{PageData?.ErrorMessage}</div> */}
                        <div className="Statepage-text">
                        <div          
                        dangerouslySetInnerHTML={{
                        __html: errorMessage ?  errorMessage({}) :''                           
                            }}
                        />

                        </div>

                        {PageData?.ButtonPage != null &&
                        (
                            <a className="Button" href={Model.ButtonUrl}>
                                <span>
                                    {PageData?.ButtonLabel}
                                    <img className="Icon" src={PageData?.Icon}/>
                                </span>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </article>
    </div>
</div>
    );
};

export default GenericErrorPageData;